import { REMI_INTERNAL_ORG } from "@remi/types/organizations";

import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";
import { projectWhere } from "./project";
import { taskWhere } from "./task";

const isInternal = (user: User) => user.person.organizationId === REMI_INTERNAL_ORG.id;

export const agentAction = {
  read: (user: User) => hasCapability(user, "agentAction.read") && isInternal(user),
  request: (user: User) => hasCapability(user, "agentAction.request") && isInternal(user),
  accept: (user: User) => hasCapability(user, "agentAction.accept") && isInternal(user),
  dismiss: (user: User) => hasCapability(user, "agentAction.dismiss") && isInternal(user),
};

export const agentActionWhere = (user: User) => ({
  task: { ...taskWhere(user), project: projectWhere(user) },
});

// Conversation rows have no relation to filter through, so this only applies the read gate. The service checks
// each conversation's readability and ownership before returning or deciding a row.
export const conversationAgentActionWhere = (user: User) =>
  agentAction.read(user)
    ? { targetKind: "CONVERSATION" }
    : { targetKind: "CONVERSATION", AND: [{ id: NON_EXISTENT_ID }] };
